import { ReactNode, useLayoutEffect, createContext, useMemo } from "react";

export const PageContext = createContext("both");
